import { render, staticRenderFns } from "./DemandPanel.vue?vue&type=template&id=ab2aeac6&scoped=true&"
import script from "./DemandPanel.vue?vue&type=script&lang=js&"
export * from "./DemandPanel.vue?vue&type=script&lang=js&"
import style0 from "./DemandPanel.vue?vue&type=style&index=0&id=ab2aeac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2aeac6",
  null
  
)

export default component.exports